/**
 * External dependencies
 */

/**
 * Internal dependencies
 */
import {
  SET_SERVICE_INITIALIZE,
  SET_SERVICE_LIST,
  SET_SERVICE_INFO
} from '@naruto/bgdcms/src/reducers/cores/service/actions';
import { errorCatch } from '@naruto/bgdcms/src/reducers/_Capture/errorCapture';
import {
  Dispatch,
  ThunkAction,
  Models,
  MiddleWare,
  ServiceList,
  ServiceListCondition,
  ServiceListAPICondition,
  ServiceInfo,
  ServiceCreateData,
  ServiceUpdateData
} from './types';

/* Initial */
/**
 * 初始化管理 store 資料
 */
export const postServiceInitialize =
  (): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(SET_SERVICE_INITIALIZE());
  };

/**
 * 取得服務列表
 */
export const getServiceList =
  (condition: ServiceListCondition): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api }): Promise<void> => {
    const result = await api.service.getServiceList<ServiceList, ServiceListAPICondition>(condition.api);
    if (!result.error && result.response) {
      dispatch(SET_SERVICE_LIST({ list: result.response, condition }));
    } else {
      const oldState = getState().service.serviceList;
      if (oldState) {
        dispatch(
          SET_SERVICE_LIST({
            list: { ...oldState.content },
            condition: { ...oldState.condition }
          })
        );
      } else {
        dispatch(
          SET_SERVICE_LIST({
            list: {
              list: [],
              pager: {
                page: 1,
                page_size: 1,
                total_page: 1,
                total_count: 1
              }
            },
            condition: {
              api: {
                page: 1,
                page_size: 40,
                with_pager: false
              }
            }
          })
        );
      }
    }
    await dispatch(errorCatch(result.error, result.status));
  };
/**
 * 更新服務列表查詢條件
 */
export const postServiceListCondition =
  (condition: ServiceListCondition): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState): Promise<void> => {
    const oldState = getState().service.serviceList;
    dispatch(SET_SERVICE_LIST({ list: { ...oldState.content }, condition }));
  };
/**
 * 取得服務資訊
 */
export const getServiceInfo =
  (serviceID: string): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api }): Promise<void> => {
    const result = await api.service.getServiceInfo<ServiceInfo>(serviceID);
    if (!result.error && result.response) {
      dispatch(SET_SERVICE_INFO({ serviceID, serviceInfo: result.response }));
    } else {
      const oldState = getState().service.serviceInfos[serviceID];
      if (oldState) {
        dispatch(SET_SERVICE_INFO({ serviceID, serviceInfo: { ...oldState } }));
      } else {
        dispatch(
          SET_SERVICE_INFO({
            serviceID,
            serviceInfo: {
              service: {
                id: serviceID,
                ctime: '',
                mtime: ''
              }
            }
          })
        );
      }
    }
    await dispatch(errorCatch(result.error, result.status));
  };
/**
 * 建立服務
 */
export const postService =
  (
    serviceData: ServiceCreateData,
    successCallback?: () => void,
    errorCallback?: () => void
  ): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api }): Promise<void> => {
    const result = await api.service.postService<ServiceInfo, ServiceCreateData>(serviceData);
    if (!result.error && result.response) {
      if (successCallback) {
        successCallback();
      }
    }
    if (result.error && errorCallback) {
      errorCallback();
    }
    await dispatch(errorCatch(result.error, result.status));
  };
/**
 * 更新服務
 */
export const putService =
  (
    serviceID: string,
    serviceData: ServiceUpdateData,
    successCallback?: () => void,
    errorCallback?: () => void
  ): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api }): Promise<void> => {
    const result = await api.service.putService<ServiceInfo, ServiceUpdateData>(serviceID, serviceData);
    if (!result.error && result.response) {
      if (successCallback) {
        successCallback();
      }
    }
    if (result.error && errorCallback) {
      errorCallback();
    }
    await dispatch(errorCatch(result.error, result.status));
  };
/**
 * 刪除服務
 */
export const deleteService =
  (
    serviceID: string,
    successCallback?: () => void,
    errorCallback?: () => void
  ): ThunkAction<Promise<void>, Models, MiddleWare, { type: string }> =>
  async (dispatch, getState, { api }): Promise<void> => {
    const result = await api.service.deleteService<ServiceInfo>(serviceID);
    if (!result.error && result.response) {
      if (successCallback) {
        successCallback();
      }
    }
    if (result.error && errorCallback) {
      errorCallback();
    }
    await dispatch(errorCatch(result.error, result.status));
  };
